import { parseZonedDateTime } from '@internationalized/date';
import { enUS } from 'date-fns/locale/en-US';
import { formatInTimeZone } from 'date-fns-tz';
import { getTzDateTimeString, getUserTimezone } from '@/utils/helpers';

export const formatSuggestionDate = (dateTime?: string | null) => {
  if (!dateTime) return '...';

  const userTimezone = getUserTimezone();
  const zoned = parseZonedDateTime(getTzDateTimeString(dateTime));

  return formatInTimeZone(zoned.toAbsoluteString(), userTimezone, 'MM/dd/yyyy HH:mm zzz', {
    locale: enUS,
  });
};
